export const useStyles = () => ({
  width: '20px !important',
  cursor: 'pointer'
});
